import React, { useState, useEffect } from "react";
import { FLASH_NOTIFICATIONS } from "../../classConstants";
import { removeNotification, sendFlashNotification } from "../../store/actions";
import { NotificationList } from "./NotificationsList";
import { connect } from "../../store/connect";
import get from "lodash/get";
import { useLocation } from "react-router";
var flashNotificationsFactory = function (NotificationList) {
    return function (_a) {
        var removeNotification = _a.removeNotification, sendFlashNotification = _a.sendFlashNotification, _b = _a.flashNotifications, flashNotifications = _b === void 0 ? [] : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
        var _d = useState(flashNotifications), allNotifications = _d[0], setAllNotifications = _d[1];
        var notificationsLength = allNotifications.length;
        var pathname = useLocation().pathname;
        React.useEffect(function () {
            sendFlashNotification([]);
        }, [pathname, sendFlashNotification]);
        useEffect(function () {
            setAllNotifications(flashNotifications);
        }, [JSON.stringify(flashNotifications)]);
        var closeNotification = function (item, index) {
            if (removeNotification)
                return removeNotification(index);
            setAllNotifications(allNotifications.filter(function (x, i) { return i !== index; }));
        };
        var renderNotifications = function () {
            return notificationsLength === 0
                ? null
                : React.createElement(NotificationList, { className: FLASH_NOTIFICATIONS, items: allNotifications, onClose: closeNotification });
        };
        return (React.createElement(React.Fragment, null, renderNotifications()));
    };
};
var smartNotificationsFactory = function (NotificationList) {
    var mapStateToProps = function (state) {
        return {
            flashNotifications: get(state.appReducer, "flashNotifications", [])
        };
    };
    return connect(mapStateToProps, { removeNotification: removeNotification, sendFlashNotification: sendFlashNotification })(flashNotificationsFactory(NotificationList));
};
export var FlashNotifications = smartNotificationsFactory(NotificationList);
